import { render, staticRenderFns } from "./DataReportOweStatistics.vue?vue&type=template&id=beb71084&scoped=true"
import script from "./DataReportOweStatistics.vue?vue&type=script&lang=js"
export * from "./DataReportOweStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataReportOweStatistics.vue?vue&type=style&index=0&id=beb71084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb71084",
  null
  
)

export default component.exports